import type { ReactNode } from "react"
import BigHeading from "../../BigHeading"
import "./styles.css"

export function WorkSection({
  children,
  className = "",
  title,
}: {
  children: ReactNode
  className?: string
  title: string
}) {
  return (
    <section className={className}>
      <BigHeading variant="h3">{title}</BigHeading>
      <div className="section-layout">{children}</div>
    </section>
  )
}

export default WorkSection
